let accessToken: string | null = null;

export const getAccessToken = (): string | null => accessToken;

export const setAccessToken = (token: string): void => {
  accessToken = token;
  localStorage.setItem('has_session', 'true');
};

export const clearAccessToken = (): void => {
  accessToken = null;
  localStorage.removeItem('has_session');
};

export const hasSession = (): boolean =>
  localStorage.getItem('has_session') === 'true';
